import { pipe } from 'fp-ts/function';

import { Http } from '@catawiki/runtime-toolkit';
import { InternalLocale } from '@catawiki/locale';

import { buyerFetchExpertsEndpoint } from '@/shared/constants/routes';

import { ExpertType } from '../types';

export const fetchExperts = (locale: InternalLocale) =>
  pipe(
    Http.get(buyerFetchExpertsEndpoint),
    Http.setSearch({
      locale,
      profile_complete_filter: true,
    }),
    Http.send<{ experts: ExpertType[] }>()
  );
